// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"40":"49a7849f60d6e2e4","509":"8be58d329b69b25a"}[chunkId] + ".js";
};